<template>
    <div class="transform">
        <div class="transform_top">提现记录</div>
    </div>
</template>
<script>
export default {
    data: function () {
        return {
       
        };
    },
    mounted: function () {},
    methods: {
     
    },
};
</script>

<style scoped>
    .transform{width: 100%;}
    .transform_top{font-size: 18px;color: #000;line-height: 40px; text-align: center;}
</style>

